import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ColorReference = () => {
  const colors = [
    {
      category: "CHA Brand Colors",
      swatches: [
        { name: "CHA Soft Purple", hsl: "282 43% 47%", hex: "#8E44AD" },
        { name: "CHA Cream", hsl: "50 67% 98%", hex: "#FAF7F2" },
        { name: "CHA Cream Frame (Spark)", hsl: "33 100% 96%", hex: "#FFF7ED" },
        { name: "CHA Logo Dark", hsl: "204 100% 26%", hex: "#004F87" },
        { name: "CHA Logo Mid", hsl: "204 59% 44%", hex: "#2E7DB2" },
        { name: "CHA Logo Light", hsl: "207 37% 72%", hex: "#A4C3D8" },
        { name: "CHA Dark Purple", hsl: "264 57% 40%", hex: "#5A2CA0" },
        { name: "CHA Teal", hsl: "187 58% 40%", hex: "#2A9CAC" },
        { name: "CHA Teal Dark", hsl: "187 95% 31%", hex: "#088799" },
        { name: "CHA Teal Light", hsl: "188 34% 52%", hex: "#59A9B5" },
      ]
    },
    {
      category: "Lime Green Accents",
      swatches: [
        { name: "Lime Jazzy", hsl: "81 91% 53%", hex: "#B1F764" },
        { name: "Lime Soft", hsl: "71 72% 68%", hex: "#CBE67A" },
        { name: "Lime Pale", hsl: "71 69% 61%", hex: "#C8E36E" },
      ]
    },
    {
      category: "Purple Accents",
      swatches: [
        { name: "Kundax Medium", hsl: "260 58% 56%", hex: "#7E3ADF" },
        { name: "Kundax Dark", hsl: "260 58% 44%", hex: "#5E2DB4" },
      ]
    },
    {
      category: "WordPress Primary Colors",
      swatches: [
        { name: "WP Primary", hsl: "195 69% 65%", hex: "#6EC1E4" },
        { name: "WP Secondary", hsl: "0 4% 33%", hex: "#54595F" },
        { name: "WP Text", hsl: "188 34% 52%", hex: "#59A9B5" },
        { name: "WP Accent", hsl: "174 47% 84%", hex: "#C4EEEB" },
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Header />
      <main className="py-20">
        <div className="container mx-auto px-4">
          <h1 className="font-display text-4xl font-bold text-foreground mb-8 text-center">
            Color Reference Guide
          </h1>
          
          {colors.map((section, idx) => (
            <div key={idx} className="mb-12">
              <h2 className="font-display text-2xl font-bold text-foreground mb-6">
                {section.category}
              </h2>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {section.swatches.map((color, colorIdx) => (
                  <div 
                    key={colorIdx}
                    className="bg-card border border-border rounded-lg p-4 shadow-soft hover:shadow-medium transition-shadow"
                  >
                    <div className="flex items-center gap-4">
                      {/* Color Swatch */}
                      <div 
                        className="w-20 h-20 rounded-lg shadow-medium flex-shrink-0 border border-border"
                        style={{ backgroundColor: color.hex }}
                      ></div>
                      
                      {/* Color Info */}
                      <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-foreground mb-2 truncate">
                          {color.name}
                        </h3>
                        <div className="space-y-1">
                          <p className="text-sm text-muted-foreground font-mono">
                            HSL: {color.hsl}
                          </p>
                          <p className="text-sm text-muted-foreground font-mono">
                            Hex: {color.hex}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          
          <div className="mt-12 p-6 bg-muted rounded-lg">
            <h3 className="font-display text-xl font-bold text-foreground mb-3">
              How to Use These Colors
            </h3>
            <div className="space-y-2 text-muted-foreground">
              <p>• In CSS/Tailwind: Use HSL format with design tokens (e.g., <code className="bg-background px-2 py-1 rounded">hsl(var(--cha-dark-purple))</code>)</p>
              <p>• In inline styles: Use hex format (e.g., <code className="bg-background px-2 py-1 rounded">#5A2CA0</code>)</p>
              <p>• All design tokens are defined in <code className="bg-background px-2 py-1 rounded">src/index.css</code></p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ColorReference;
